import { render } from "./icon_drag.vue?vue&type=template&id=3bed9b97"
import script from "./icon_drag.vue?vue&type=script&lang=js"
export * from "./icon_drag.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/icon_drag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bed9b97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bed9b97', __exports__)) {
    api.reload('3bed9b97', __exports__)
  }
  
  module.hot.accept("./icon_drag.vue?vue&type=template&id=3bed9b97", () => {
    api.rerender('3bed9b97', render)
  })

}


export default __exports__